import React, { useState } from "react";
import { FileUploaderDropContainer, FileUploaderItem } from "carbon-components-react";

import { Upload, UploadField, UploadType, UploadTypeDisplayValues } from "@eave/shared/types/api";

import { getFileDownloadBaseURL } from "config";

import { FormikErrors } from "formik";

import { createUpload, deleteUpload } from "./api";

const styles = require("./styles.module.scss");

const errorMsg = "There was a problem with this upload. Please contact eng.";

// TODO: jjw: remove if/when we attach the whole upload instead of just id+s3_key
interface ExistingUpload {
  [UploadField.Id]: number;
  [UploadField.S3Key]: string;
}

interface Props {
  id?: string;
  uploadType: UploadType;
  contentTypes: string[];
  details: string;
  existingUpload: ExistingUpload;
  onUploadHook?: Function;
  onDeleteHook?: Function;
  invalidText?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
}

const Uploader: React.FC<Props> = ({
  id,
  uploadType,
  contentTypes,
  details,
  existingUpload,
  onUploadHook = () => {},
  onDeleteHook = () => {},
  invalidText,
}) => {
  const [uploadingFileName, setUploadingFileName] = useState<string | null>(null);
  const [upload, setUpload] = useState<Upload | ExistingUpload | null>(
    existingUpload.id ? existingUpload : null,
  );

  const onUpload = async e => {
    const file = e.target.files[0];
    setUploadingFileName(file.name);

    try {
      const upload = await createUpload(file, uploadType);
      setUpload(upload);
      onUploadHook(upload);
    } catch (e) {
      window.alert(errorMsg);
      throw e;
    } finally {
      setUploadingFileName(null);
    }
  };

  const onDelete = async () => {
    try {
      await deleteUpload(upload.id);
      setUpload(null);
      onDeleteHook();
    } catch (e) {
      window.alert(errorMsg);
      throw e;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <p className={styles.label}>Upload {UploadTypeDisplayValues[uploadType]}</p>
        <p className={styles.details}>{details}</p>
        {invalidText && <p className={styles.error}>{invalidText}</p>}
      </div>
      {uploadingFileName && (
        <FileUploaderItem name={uploadingFileName} status="uploading" size="small" />
      )}
      {upload && (
        <FileUploaderItem name={upload.s3_key} status="edit" size="small" onDelete={onDelete} />
      )}
      {upload ? (
        <img className={styles.image} src={getFileDownloadBaseURL(upload.s3_key)} />
      ) : (
        <FileUploaderDropContainer
          id={id}
          labelText="Click here (or drag and drop) to upload"
          mulitple="false"
          accept={contentTypes}
          disabled={!!uploadingFileName}
          onChange={onUpload}
        />
      )}
    </div>
  );
};

export default Uploader;
